import React, { useState } from 'react';
import { sendEmail } from './api';
import PageHeader from './PageHeader';
import socialLinks from './socialLinks';
import styles from '../css/ContactForm.module.css';
import mailIcon from '../assets/Mail.png';
import information from '../assets/Information.png';
import mobile from '../assets/Mobile.png';
import location from '../assets/Location.png';

export const ContactUs = () => {  

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
    receiveInfo: false,
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setErrorMessage('Please enter a valid email address.');
      return false;
    }

    if (formData.name.trim() === '') {
      setErrorMessage('Please enter your name.');
      return false;
    }

    if (formData.message.trim() === '') {
      setErrorMessage('Please enter a message.');
      return false;
    }

    setErrorMessage('');
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.receiveInfo) {
      setErrorMessage('Please check the box to agree to the Privacy Policy.');
      return;
    }

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setSuccessMessage('');

    try {
      await sendEmail(formData);
      setSuccessMessage('Email sent successfully!');
      setFormData({ name: '', email: '', phone: '', message: '', receiveInfo: false });
      setFormSubmitted(true);
    } catch (error) {
      setErrorMessage('A network error occurred. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const contactData = [
    { icon: mailIcon, title: 'Email us', content: <a href="mailto:info@manvidia.com">info@manvidia.com</a> },
    { icon: mobile, title: 'Call us', content: <a href="tel:+918860018741">+91-8860018741</a> },
    { icon: information, title: 'Internships', content: <>Contact us at <a href="mailto:careers@manvidia.com">careers@manvidia.com</a></> },
    { icon: location, title: 'Address', content: 'Supertech Capetown, NOIDA 201301' },
  ];

  return (
    <div>
      <PageHeader eyebrow="Contact" title="Let's talk">
        Tell us what you're working on and we'll get back to you.
      </PageHeader>

      <div className="page section">
        <div className={styles.card}>
          <div className={styles.formSection}>
            <h2>Write To Us</h2>
            <form onSubmit={handleSubmit}>
              {errorMessage && <div className={styles.error_message} role="alert">{errorMessage}</div>}
              {successMessage && <div className={styles.success_message} role="status">{successMessage}</div>}

              <div className={styles.row}>
                <label className={styles.field}>
                  <span>Name</span>
                  <input type="text" id="name" name="name" placeholder="Your name" value={formData.name} onChange={handleInputChange} required />
                </label>
                <label className={styles.field}>
                  <span>Phone</span>
                  <input type="tel" id="phone" name="phone" placeholder="Your phone number" value={formData.phone} onChange={handleInputChange} required />
                </label>
              </div>
              <label className={styles.field}>
                <span>Email</span>
                <input type="email" id="email" name="email" placeholder="you@example.com" value={formData.email} onChange={handleInputChange} required />
              </label>
              <label className={styles.field}>
                <span>Message</span>
                <textarea id="message" name="message" placeholder="How can we help?" value={formData.message} onChange={handleInputChange} required />
              </label>
              <label className={styles.checkboxLabel}>
                <input type="checkbox" name="receiveInfo" checked={formData.receiveInfo} onChange={handleInputChange} />
                <span>I'd like to receive more information about the company. I understand and agree to the Privacy Policy.</span>
              </label>
              <button type="submit" className="btn" disabled={loading}>
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>

          <aside className={styles.infoSection}>
            <h2>Contact details</h2>
            <ul className={styles.contactList}>
              {contactData.map((item) => (
                <li key={item.title}>
                  <span className={styles.contactIcon}>
                    <img src={item.icon} alt="" />
                  </span>
                  <div>
                    <strong>{item.title}</strong>
                    <div>{item.content}</div>
                  </div>
                </li>
              ))}
            </ul>

            <p className={styles.socialTitle}>Follow our social handles</p>
            <div className="social-links">
              {socialLinks.map(({ label, href, Icon }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                  <Icon />
                </a>
              ))}
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
